import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/dist/query/react'
import { env } from '../lib/config/env'

interface RefreshTokenResponse {
    accessToken: string
}

interface AwsBucketBody {
    url: string
    file: string | File
    /**
     * Sent as the PUT's Content-Type. Required when the presigned URL was
     * signed for a specific mimeType — otherwise the browser derives it from
     * `File.type`, which is empty for some files, and S3 rejects the upload.
     */
    contentType?: string
}

export const customApi = createApi({
    reducerPath: 'customApi',
    baseQuery: fetchBaseQuery({
        baseUrl: env.apiUrl,
    }),
    endpoints: (build) => ({
        sendImgToAwsBucket: build.mutation<void, AwsBucketBody>({
            query: (body) => ({
                url: body.url,
                method: 'PUT',
                body: body.file,
                ...(body.contentType && {
                    headers: { 'Content-Type': body.contentType },
                }),
                options: {
                    excludeHeaders: true,
                },
            }),
        }),
        refreshToken: build.mutation<RefreshTokenResponse, string>({
            query: (token) => ({
                url: 'auth/refresh',
                method: 'POST',
                headers: { Authorization: `Bearer ${token}` },
            }),
        }),
    }),
})
export const {
    useSendImgToAwsBucketMutation,
    useRefreshTokenMutation,
    endpoints: { refreshToken },
} = customApi
